window.addEventListener('DOMContentLoaded', e => {
	const banner = document.querySelector('.banner')

	if (banner) {
		const header = document.querySelector('header.header')
		banner.style.setProperty('--banner-height', `${banner.scrollHeight}px`)

		// Check if banner has already been seen and closed
		let seenContent = window.localStorage.getItem('banner-content-seen')

		let contentHash = hashCode(banner.innerHTML)
		let contentArr = []

		if (!checkSeenContent()) {
			banner.classList.add('show')
		} else {
			banner.remove()
			document.documentElement.style.setProperty(
				'--header-offset',
				`${header.scrollHeight - banner.scrollHeight}px`,
			)
		}

		// Handle banner close
		const closeBtn = banner.querySelector('.close-btn')
		if (closeBtn) {
			closeBtn.addEventListener('click', () => {
				document.documentElement.style.setProperty(
					'--header-offset',
					`${header.scrollHeight - banner.scrollHeight}px`,
				)
				banner.classList.remove('show')
				if (!checkSeenContent()) {
					contentArr.push(contentHash)
				}
				window.localStorage.setItem(
					'banner-content-seen',
					JSON.stringify(contentArr),
				)
			})
		}

		function checkSeenContent() {
			// Checks if there is any value for seen content in local storage
			// If not, return false
			// If yes, but current content has not been seen, return false
			// If yes, but current content has been seen, return true

			if (!seenContent) {
				return false
			}

			contentArr = JSON.parse(seenContent)
			if (!contentArr.includes(contentHash)) {
				return false
			}

			return true
		}

		window.addEventListener('resize', () => {
			banner.style.setProperty('--banner-height', `${banner.scrollHeight}px`)
		})
	}

	function hashCode(str) {
		let hash = 0
		for (let i = 0, len = str.length; i < len; i++) {
			let chr = str.charCodeAt(i)
			hash = (hash << 5) - hash + chr
			hash |= 0 // Convert to 32bit integer
		}
		return hash
	}
})
